var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const withSubComponent = /* @__PURE__ */ __name((component, subComponents) => {
  const enhancedComponent = component;
  for (const [key, value] of Object.entries(subComponents)) {
    enhancedComponent[key] = value;
  }
  return enhancedComponent;
}, "withSubComponent");

export { withSubComponent };
//# sourceMappingURL=with-sub-components.js.map
